import React from "react"
import Relay from "react-relay"
import { FormattedMessage } from "react-intl"
import { default as mediaMessages } from "../../messages/media"

const typeName = {
  audio: "audio clip",
  video: "video file",
  image: "image"
}

class MediaMissing extends React.Component {
  render() {
    const { resource, file } = this.props
    const media = file || resource
    const type = media.type in typeName ? typeName[media.type] : media.type

    return (
      <div className="row column">
        <p className="c-mviewer__media-missing">
          <FormattedMessage
            {...mediaMessages.mediaMissing}
            values={{ type: type }}
          />
        </p>
      </div>
    )
  }
}

export default Relay.createContainer(MediaMissing, {
  fragments: {
    resource: () => Relay.QL`
    fragment on Resource {
        type
        source
        access_rights
    }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/MediaMissing.js